import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import { setPriceSource } from "../store/settings";
import styles from "../styles/Settings.module.scss";
import useDarkMode from "use-dark-mode";
import { v4 } from "uuid";

const Settings = ({ handleClose, show }) => {
  const darkMode = useDarkMode(false);
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Row>
            <Form.Label column xs={3}>
              Dark Mode
            </Form.Label>
            <Col className={styles.darkModeSlider}>
              <Form.Switch
                id="dark-mode"
                checked={darkMode.value}
                label={<FontAwesomeIcon icon={darkMode.value ? "moon" : "sun"} />}
                onChange={darkMode.toggle}
              />
            </Col>
          </Form.Row>
          {settings.priceSources.map((priceSource, i) => {
            return (
              <Fragment key={v4()}>
                <br />
                <Form.Row>
                  <Form.Label column xs={3}>
                    {`Price Source ${i + 1}`}
                  </Form.Label>
                  <Col>
                    <Form.Control
                      as="select"
                      onChange={(e) => dispatch(setPriceSource({ i, priceSource: e.target.value }))}
                      value={priceSource}
                    >
                      <option value="cardkingdom">Card Kingdom (US)</option>
                      <option value="tcgplayer">TCGplayer (US)</option>
                      <option value="cardhoarder">Cardhoarder (MTGO)</option>
                      <option value="cardmarket">Cardmarket (EU)</option>
                      <option value="coolstuffinc">CoolStuffInc (US)</option>
                    </Form.Control>
                  </Col>
                </Form.Row>
              </Fragment>
            );
          })}
        </Form.Group>
      </Modal.Body>
    </Modal>
  );
};

Settings.propTypes = {
  handleClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default Settings;
